<mat-select [(ngModel)]="project.opening.shape" [compareWith]="shapeComparisonFunction" panelWidth=""
  [ngClass]="{'pencilTrigger':pencilTrigger}" panelClass="shapes">
  @if (pencilTrigger) {
    <mat-select-trigger>
      <mat-icon class="current-icon" svgIcon="shape-{{project.opening.shape[0].code}}"></mat-icon>
      <button mat-mini-fab color="secondary" class="extra-small" >
        <mat-icon svgIcon="menu-down"></mat-icon>
      </button>
    </mat-select-trigger>
  }
  @for (data of shapeData; track data.shape) {
    <mat-option [value]="[data.shape]">
      <mat-icon [svgIcon]="data.icon"></mat-icon>
      <!--<img [src]="data.preview" />-->
      {{ data.shape.description }}
    </mat-option>
  }
</mat-select>
